import { render } from "./termsPolicy.vue?vue&type=template&id=6253260a&scoped=true"
import script from "./termsPolicy.vue?vue&type=script&lang=js"
export * from "./termsPolicy.vue?vue&type=script&lang=js"

import "./termsPolicy.vue?vue&type=style&index=0&id=6253260a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6253260a"]])

export default __exports__